import './index.css';
import './globals.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { SpeedInsights } from "@vercel/speed-insights/react";
import App from './App';

const host = typeof window !== 'undefined' ? window.location.hostname : '';
const enableSpeedInsights = import.meta.env.PROD && (
  host.endsWith('vercel.app') ||
  host === 'unislumen.com' ||
  host.endsWith('.unislumen.com')
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <App />
    {enableSpeedInsights ? <SpeedInsights /> : null}
  </>
);
